var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMasordenBlancoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "32px",
    viewBox: "0 0 123 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xC1tomo / Logo / Gris / 40px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explorations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consola-Nav-Estadisticas",
    transform: "translate(-16.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.824,16.4 C57.8376969,17.5600006 57.6592855,18.7142684 57.296,19.816 C56.9548951,20.8109044 56.409949,21.7236891 55.696,22.496 C55.0007922,23.2556026 54.1455249,23.8512839 53.192,24.24 C51.0131947,25.0596012 48.6108053,25.0596012 46.432,24.24 C45.5064491,23.838382 44.6773038,23.2437975 44,22.496 C43.2858638,21.7268848 42.7408183,20.8166589 42.4,19.824 C42.0346987,18.7198013 41.8536122,17.5630099 41.864,16.4 C41.8541997,15.2396497 42.0352824,14.0855852 42.4,12.984 C42.7408183,11.9913411 43.2858638,11.0811152 44,10.312 C44.6944977,9.55158648 45.5499607,8.9557688 46.504,8.568 C48.6804957,7.73579608 51.0875043,7.73579608 53.264,8.568 C54.2180393,8.9557688 55.0735023,9.55158648 55.768,10.312 C56.4666294,11.0842365 56.9953647,11.9945334 57.32,12.984 C57.678356,14.0863507 57.848733,15.241128 57.824,16.4 Z M54.728,16.4 C54.7583403,15.5213727 54.6476014,14.6435639 54.4,13.8 C54.1938724,13.1191555 53.8508632,12.487583 53.392,11.944 C52.9703509,11.4588115 52.4418064,11.07815 51.848,10.832 C50.5901252,10.3415013 49.1938748,10.3415013 47.936,10.832 C47.3445027,11.0781954 46.8185737,11.4589461 46.4,11.944 C45.9384637,12.4870147 45.5927281,13.1185946 45.384,13.8 C45.1228692,14.6413627 44.998619,15.5192172 45.016,16.4 C44.9985917,17.2834081 45.1228329,18.1639001 45.384,19.008 C45.5928903,19.6869286 45.9386667,20.3158604 46.4,20.856 C46.8209167,21.338495 47.3462021,21.7187798 47.936,21.968 C49.1938748,22.4584987 50.5901252,22.4584987 51.848,21.968 C52.44138,21.7210857 52.9697611,21.3405418 53.392,20.856 C53.8493882,20.3114108 54.1922253,19.6801552 54.4,19 C54.643524,18.1555912 54.7541809,17.2784331 54.728,16.4 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.104,13.144 C73.1358785,14.1897663 72.8020418,15.2139094 72.16,16.04 C71.3911377,16.9173154 70.3674913,17.532622 69.232,17.8 L69.232,17.848 L74.096,24.552 L70.504,24.552 L66.048,18.24 L64,18.24 L64,24.552 L61,24.552 L61,8.24792667 L65.976,8.24792667 C66.7434084,8.24584318 67.5102125,8.29126363 68.272,8.384 C68.89335,8.46005598 69.5048112,8.60219388 70.096,8.808 C70.9785561,9.11100177 71.752156,9.66754846 72.32,10.408 C72.8696612,11.2115354 73.144682,12.171302 73.104,13.144 Z M65.48,15.744 C66.0548068,15.7492592 66.6293486,15.7171918 67.2,15.648 C67.6118814,15.604663 68.0172934,15.5133782 68.408,15.376 C68.9204918,15.2192177 69.3619912,14.8880931 69.656,14.44 C69.894483,14.0298874 70.0162111,13.5623407 70.008,13.088 C70.0139255,12.6823124 69.9205463,12.2813311 69.736,11.92 C69.5202861,11.5578087 69.191365,11.2766795 68.8,11.12 C68.4552267,10.9755462 68.0915287,10.8812541 67.72,10.84 C67.1896439,10.7698283 66.6549416,10.7377462 66.12,10.744 L64,10.744 L64,15.744 L65.48,15.744 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.728,24.552 L76.728,8.248 L81.056,8.248 C81.44,8.248 81.856,8.248 82.224,8.248 C82.592,8.248 83.024,8.312 83.384,8.36 C83.744,8.408 84.12,8.464 84.472,8.536 C84.7964065,8.60055908 85.1169151,8.68335714 85.432,8.784 C86.2542622,9.03980906 87.0335735,9.41733008 87.744,9.904 C88.3974572,10.3588131 88.966073,10.9247212 89.424,11.576 C89.8862368,12.2303905 90.2351041,12.9578735 90.456,13.728 C90.6930504,14.5658422 90.8088929,15.4333144 90.8,16.304 C90.8060661,17.134072 90.7093301,17.9617015 90.512,18.768 C90.3224524,19.5236083 90.014654,20.2445045 89.6,20.904 C89.1927695,21.5440626 88.6817784,22.1118305 88.088,22.584 C87.4396087,23.0927386 86.7127855,23.4926265 85.936,23.768 C85.1599782,24.0505565 84.3550846,24.2464139 83.536,24.352 C82.5505005,24.4939756 81.5556346,24.5608349 80.56,24.552 L76.728,24.552 Z M80.952,22.056 C82.3588867,22.1205305 83.7627407,21.8747195 85.064,21.336 C85.9048536,20.9339911 86.5966469,20.2758072 87.04,19.456 C87.5229237,18.4805225 87.7539469,17.3996636 87.712,16.312 C87.719061,15.7051339 87.6464408,15.0999658 87.496,14.512 C87.3597126,14.0038339 87.1436962,13.5204973 86.856,13.08 C86.5843782,12.6648916 86.2434121,12.2995708 85.848,12 C85.4411293,11.6884836 84.991077,11.4378557 84.512,11.256 C84.0108452,11.0680527 83.4902956,10.9365737 82.96,10.864 C82.3234988,10.7801244 81.6819916,10.7400302 81.04,10.744 L79.72,10.744 L79.72,22.056 L80.952,22.056 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "96.968 22.048 104.968 22.048 104.968 24.552 93.976 24.552 93.976 8.248 104.576 8.248 104.576 10.752 96.976 10.752 96.976 14.96 103.504 14.96 103.504 17.456 96.976 17.456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.712,15.824 C117.88,17.488 118.84,18.968 119.568,20.256 L119.648,20.256 C119.544,18.136 119.496,16.592 119.496,15.624 L119.496,8.24 L122.488,8.24 L122.488,24.544 L119.344,24.544 L114.016,17.04 C113.072,15.744 112.104,14.232 111.104,12.52 L111.032,12.52 C111.128,14.52 111.176,16.064 111.176,17.16 L111.176,24.544 L108.184,24.544 L108.184,8.24 L111.32,8.24 L116.712,15.824 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#53E4B1",
    fillRule: "nonzero",
    points: "15.848 32 38.48 32 38.48 9.368 34.72 9.368 38.112 27.936"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0DDA9A",
    fillRule: "nonzero",
    points: "15.848 32 38.112 27.936 34.72 9.368 32.664 9.368 37.512 25.472"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#05CBDB",
    fillRule: "nonzero",
    points: "32.664 9.368 28.984 9.368 35.496 20.776 15.848 32 37.512 25.472"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0DA9C6",
    fillRule: "nonzero",
    points: "28.984 9.368 25.384 9.368 32.048 16.2 15.848 32 35.496 20.776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0386C8",
    fillRule: "nonzero",
    points: "15.848 32 32.048 16.2 25.384 9.368 15.848 9.368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0699E6",
    fillRule: "nonzero",
    points: "23.632 7.576 22.464 6.376 9.216 10.368 15.848 32 15.848 9.368 25.384 9.368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0DB2FD",
    fillRule: "nonzero",
    points: "22.464 6.376 19.824 3.664 4.576 12.352 15.848 32 9.216 10.368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0AC5F4",
    fillRule: "nonzero",
    points: "19.824 3.664 16.24 0 0 15.792 15.848 32 4.576 12.352"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0DB2FD",
    fillRule: "nonzero",
    points: "22.464 6.376 26.56 5.144 28.984 9.368 25.384 9.368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0DDADA",
    fillRule: "nonzero",
    points: "26.56 5.144 24.272 1.128 19.824 3.664 22.464 6.376"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#53E4B1",
    fillRule: "nonzero",
    points: "26.56 5.144 30.992 3.808 31.68 6.112 27.544 6.864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0DDA9A",
    fillRule: "nonzero",
    points: "28.984 9.368 32.664 9.368 31.68 6.112 27.544 6.864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#53E4B1",
    fillRule: "nonzero",
    points: "31.68 6.112 34.048 5.68 34.72 9.368 32.664 9.368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "28.376 16.728 20.936 16.728 20.936 24.048 18.4 24.048 18.4 16.728 10.96 16.728 10.96 14.08 18.28 14.08 18.28 6.76 20.936 6.76 20.936 14.08 28.376 14.08"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMasordenBlancoSmall);
export default __webpack_public_path__ + "static/media/logo-masorden-blanco-small.5a0786d7d89ce0a0418ae397ae535925.svg";
export { ForwardRef as ReactComponent };